import {fetch} from "utils/dataAccess";

export async function wmsTakeout(shipment, cancellationReason) {
    const response = await fetch(`/shipments/${shipment.id}/takeout`, {
        method: 'POST',
        body: JSON.stringify({
            reason: cancellationReason
        })
    });

    if (!response.ok) {
        throw new Error('Failed to takeout WMS shipment');
    }

    return await response.json();
}
